import { useCallback } from 'react';

import { COMPLETED_STATUS_KEY, EXPIRED_STATUS_KEY } from '@redux/actions/cpSaleOrderStatuses/configs';

const useCheckDisablePurchaseButton = () => {
  return useCallback((cartStatus) => cartStatus === EXPIRED_STATUS_KEY || cartStatus === COMPLETED_STATUS_KEY, []);
};

export default useCheckDisablePurchaseButton;
